import { render, staticRenderFns } from "./GameDataCorrectionList.vue?vue&type=template&id=9d12933a&"
import script from "./GameDataCorrectionList.vue?vue&type=script&lang=js&"
export * from "./GameDataCorrectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports